<template lang='pug'>
div
  slot(
    :focused_update='focused_update'
    :nutrient='nutrient'
    :nutrient_value='nutrient_value'
    :nutrient_value_update='nutrient_value_update'
  )
    v-text-field(
      autocomplete='off'
      type='number'
      :value='nutrient_value'
      @blur='focused_update(false)'
      @focus='focused_update(true)'
      @input='nutrient_value_update'
    )
      template(
        v-slot:label
      )
        LabelNutrient(
          :nutrient='nutrient'
        )
</template>

<script>
import LabelNutrient from './LabelNutrient.vue';

const nutrient_value_update = function (nutrient_value)
{
  this.$emit('update:nutrient_value', nutrient_value ? window.Number(nutrient_value) : '');
};

const focused_update = function (focused)
{
  this.focused = focused;

  this.nutrient_value = this.focused
  ? this.nutrient_value
  : this.nutrient_value_initial;
};

export default
{
  components:
  {
    LabelNutrient,
  },
  data()
  {
    return {
      focused: false,
      nutrient_value: null,
    };
  },
  methods:
  {
    focused_update,
    nutrient_value_update,
  },
  props:
  {
    nutrient: { required: true },
    nutrient_value_initial: { required: true },
  },
  watch:
  {
    nutrient_value_initial:
    {
      handler()
      {
        this.nutrient_value = this.focused
        ? this.nutrient_value
        : this.nutrient_value_initial;
      },
      immediate: true,
    },
  },
};
</script>